export default __webpack_public_path__ + "static/media/gunshot.12621986.mp3";